import { TLegalType } from '@/models/financialSettings.model';

export enum CashRegisterFormFields {
  NAME = 'name',
  NUMBER = 'number',
  FISCAL_NUMBER = 'fiscal_number',
  LEGAL_TYPE = 'legal_type',
  IS_VIRTUAL = 'is_virtual',
  IS_ACTIVE = 'is_active',
  FISCAL_DEPARTMENT = 'fiscal_department',
  LICENSE_KEY = 'license_key',
  CASHIER_NAME = 'cashier_name',
  CASHIER_LOGIN = 'cashier_login',
  CASHIER_PIN_CODE = 'cashier_pin_code',
}

export interface TCashRegisterFormValues {
  [CashRegisterFormFields.NAME]: string;
  [CashRegisterFormFields.NUMBER]?: string;
  [CashRegisterFormFields.FISCAL_NUMBER]?: string;
  [CashRegisterFormFields.LEGAL_TYPE]: TLegalType;
  [CashRegisterFormFields.IS_VIRTUAL]: boolean;
  [CashRegisterFormFields.IS_ACTIVE]: boolean;
  [CashRegisterFormFields.FISCAL_DEPARTMENT]?: string;
  [CashRegisterFormFields.LICENSE_KEY]?: string;
  [CashRegisterFormFields.CASHIER_NAME]: string;
  [CashRegisterFormFields.CASHIER_LOGIN]: string;
  [CashRegisterFormFields.CASHIER_PIN_CODE]?: string;
}
